import { Injectable } from '@angular/core';
import { StudyBundleCourseDto } from '../types/StudyBundleCourseDto';
import { LogService } from '../log.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MediaPlayerComponent } from './media-player.component';
import { ImmersionCourseService } from '../immersion-course.service';
import { GenericModalService } from '../generic-modal/generic-modal.service';
import { TranslatePipe } from '../translate.pipe';
import { Subject } from 'rxjs';
import { ActivityType } from '../../activity-calendar/activity-snippet/activity-type';
import { CourseContentType } from '../types/course-content-type';

interface MediaPlayerEventModel {
  mediaItem: StudyBundleCourseDto;
  startTime: number;
  endTime: number;
  complete: boolean;
}

@Injectable({ providedIn: 'root' })
export class NgMediaPlayerService {
  modalRef: NgbModalRef;

  playerClosed = new Subject();

  constructor(
    private modalService: NgbModal,
    private translatePipe: TranslatePipe,
    private genericModalService: GenericModalService,
    private immersionCourseService: ImmersionCourseService
  ) {}

  public playMedia(mediaItem: StudyBundleCourseDto, setStartTime = false) {
    const activityType: ActivityType = mediaItem.type as ActivityType;
    LogService.log(`Playing media item ${mediaItem.id}`);

    if (this.modalRef) {
      this.modalRef.close();
    }

    this.modalRef = this.modalService.open(MediaPlayerComponent, {
      windowClass: `modal-video modal-${
        mediaItem.type === 'News' ? 'news' : 'common'
      }`,
    });
    this.modalRef.componentInstance.mediaItemValue = mediaItem;
    this.modalRef.componentInstance.width = 750;

    if (setStartTime) {
      this.modalRef.componentInstance.startTime = new Date().getTime();
    }

    this.modalRef.componentInstance.close.subscribe(() =>
      this.modalRef.close()
    );

    this.modalRef.componentInstance.destroy.subscribe(
      (data: MediaPlayerEventModel) => {
        if (data.startTime) {
          // Make sure they clicked the start button
          if (!data.endTime) {
            // They could have just closed the window, set an end time
            data.endTime = new Date().getTime();
          }

          this.savePersonCourse(data, activityType);
        }
      }
    );
  }

  savePersonCourse(data: MediaPlayerEventModel, activityType: ActivityType) {
    const courseType = this.getCourseContentType(activityType);

    this.immersionCourseService
      .savePersonCourse(
        Math.ceil((data.endTime - data.startTime) / 1000),
        data.complete,
        data.mediaItem.id,
        courseType,
      )
      .subscribe(
        () => this.playerClosed.next(),
        () => {
          this.genericModalService.show(
            this.translatePipe.transform('alert.titleError'),
            this.translatePipe.transform('errors.unablePerformAction')
          );
        }
      );
  }

  private getCourseContentType(activityType: ActivityType): CourseContentType {
    switch (activityType) {
      case ActivityType.IDIOMS:
        return CourseContentType.IDIOMS;
      case ActivityType.NEWS:
        return CourseContentType.DAILY_NEWS;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/media-player/ng-media-player.service.ts